import { render, staticRenderFns } from "./editBook.vue?vue&type=template&id=2bc7c404&scoped=true"
import script from "./editBook.vue?vue&type=script&lang=js"
export * from "./editBook.vue?vue&type=script&lang=js"
import style0 from "./editBook.vue?vue&type=style&index=0&id=2bc7c404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc7c404",
  null
  
)

export default component.exports